import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";

const ProtectedRoute = ({ children }) => {
  const { user: currentUser, loading } = useSelector((state) => state.auth);

  let location = useLocation();

  if (!currentUser && !loading) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return (
    <>
      <Sidebar />
      <Box>
        <Toolbar />
        <Outlet />
      </Box>
    </>
  );
};

export default ProtectedRoute;
